<template>
   <div id="jumbo-wrapper">
      <div
         id="jumbotron"
         class="jumbotron frontpage-jumbotron rounded-0 position-relative">
         <variant-indicator />
         <div
            id="material-wrap"
            v-touch:tap="void 0"
            class="container-fluid container-lg py-8">
            <div
               id="frontFormular"
               class="row old">
               <div class="col-md-5">
                  <div
                     style="margin: 10px"
                     :class="{ 'text-center': width <= 992 }">
                     <slot>
                        <h1 v-html="headline" />
                     </slot>
                     <h2
                        v-if="subtitle"
                        v-html="subtitle" />
                     <h2 v-else>
                        Vælg forsikringer, sammenlign tilbud
                        <br />
                        og spar op til 30%
                     </h2>
                  </div>
               </div>
               <div
                  v-if="custom.type === 'wistia'"
                  class="col-md-7"
                  :class="{ 'xs': breakpoint === 'xs', 'mt-md': small }">
                  <wistia-player :video-id="custom.videoId" />
               </div>
               <div
                  v-else
                  id="main-product-grid"
                  class="col-md-7">
                  <div class="position-relative">
                     <div
                        class="skilt"
                        :style="{
                           width: small ? '110px' : '120px',
                           // left: breakpoint === 'xs' ? '0' : '-15px',
                           // top: breakpoint === 'xs' ? '-20px' : '-25px',
                        }" />
                     <div class="super-header d-none d-lg-block">Vælg forsikringer...</div>
                     <products-grid
                        id="material-products"
                        class="product-selectors"
                        legacy
                        :limit="4"
                        :intro="true" />
                     <submit-products-button
                        wrapper="#main-product-grid"
                        old />
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div>
</template>

<script>
import SubmitProductsButton from '@components/SubmitProductsButton';
import ProductsGrid from '@components/ProductsGrid';
import WistiaPlayer from '@components/WistiaPlayer';
import { mapGetters } from 'vuex';
import Pin from '@components/Pin';
import VariantIndicator from '@components/VariantIndicator';

export default {
   name: 'FindforsikringJumboOld',
   components: { VariantIndicator, Pin, WistiaPlayer, ProductsGrid, SubmitProductsButton },
   props: {
      custom: {
         type: Object,
         default: function () {
            return {};
         },
      },
   },
   computed: {
      ...mapGetters(['breakpoint', 'header', 'containerClass', 'width', 'small']),
      headline() {
         return this.$store.getters.headline;
      },
      landingpage() {
         return this.$store.state.landingpage;
      },
      subtitle() {
         return this.landingpage && this.landingpage.subtitle ? this.landingpage.subtitle : null;
      },
   },
};
</script>

<style lang="scss" scoped>
#jumbo-wrapper {
   background: linear-gradient(
      to bottom,
      rgba(203, 220, 226, 0.1) 0%,
      rgba(188, 215, 226, 0.4) 78%,
      rgba(138, 200, 226, 0.6) 100%
   );
}
#jumbotron {
   --img-url: url(/wp-content/themes/findforsikring_2015-sommer/images/graphics/landskab_ekstra_bakker.png);
   background: var(--img-url) repeat-x center bottom;
   //#material-wrap {
   //   background-image: ;
   //   background-repeat: repeat-x;
   //   background-position: center bottom;
   //}
   //&:before {
   //   content: '';
   //   background: linear-gradient(
   //      to bottom,
   //      rgba(203, 220, 226, 0.1) 0%,
   //      rgba(188, 215, 226, 0.4) 68%,
   //      rgba(138, 200, 226, 0.6) 90%
   //   );
   //   position: absolute;
   //   top: 0;
   //   left: 0;
   //   width: 100%;
   //   height: 100%;
   //}
}

.skilt {
   background-size: contain !important;
   height: 39px;
   top: -25px;
   color: var(--ff-blue);
   position: absolute;
   width: 124px;
   z-index: 500;
   background: url(/wp-content/themes/findforsikring_2015-sommer/images/graphics/forside-skilt.png) no-repeat left top
      transparent;
}

#material-wrap {
   font-size: 14px;

   .spacer {
      height: 75px;

      &.xs {
         height: 0;
      }
   }

   &.md {
      font-size: 14px;
   }

   &.sm {
      font-size: 12px;
   }

   &.xs {
      font-size: 10px;

      .extra-space {
         height: 0;
      }

      .spacer.top {
         height: 3em;
      }
   }

   &.md,
   &.lg {
      //.col-md-6 {
      //    padding: 0 !important;
      //}
   }

   .header-spacing {
      height: 0;
      transition: height 0.3s;

      &.active {
         height: 50px;
      }
   }

   h1 {
      //font-size: 270%;
      font-weight: 800;
      font-stretch: 100%;
      margin-top: 0;
   }

   h2 {
      font-size: 170%;
   }

   .col-md-6 {
      //padding: 0 !important;

      //&.xs {
      //    margin: 0 15px;
      //}
   }

   .super-header {
      text-align: center;
      font-size: 120%;
      position: absolute;
      top: -25px;
      left: calc(50% - 3.9em);
   }

   #more-wrap {
      width: 160px;
      margin: 10px auto;
      background-color: #fff;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 5px 10px;
      border-radius: 3px;
      position: relative;

      .more-button {
         //font-family: 'Amaranth', sans-serif;
         font-size: 18px;
      }
   }

   .cell {
      width: 170px;
      margin: 0 auto;
      height: 50px;
   }
}
</style>
